export const SPARTACUS_PLAN_VALUES = ['Free', 'Starter', 'Growth', 'Pro']

export const SPARTACUS_CHANNEL_VALUES = ['TFR', 'GREEN', 'JUST', 'Direct']

export const SPARTACUS_ORDER_TREND_VALUES = [
  'up',
  'down',
  'flat',
  'new',
  'no_prior',
]

export const SPARTACUS_ORDER_TREND_LABELS = {
  up: 'Up',
  down: 'Down',
  flat: 'Flat',
  new: 'New',
  no_prior: 'No prior activity',
}

export const SPARTACUS_PRESET_IDS = [
  'high_upgrade_potential',
  'at_risk_paid',
  'declining_free',
  'recently_activated_low_adoption',
  'xero_not_connected_high_activity',
]

export const SPARTACUS_ACTIVE_SUPPLIER_BUCKET_VALUES = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5plus',
]

export const SPARTACUS_ACTIVE_SUPPLIER_BUCKET_LABELS = {
  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  '5plus': '5+',
}

export const SPARTACUS_ACTIVE_SUPPLIER_BELOW_GOAL_BUCKETS = [
  '0',
  '1',
  '2',
  '3',
  '4',
]

export const SPARTACUS_ACTIVE_SUPPLIER_AT_GOAL_BUCKETS = ['5plus']

export const SPARTACUS_LAST_SEEN_NOT_TRACKED_LABEL = 'Not tracked yet'
export const SPARTACUS_LAST_VENUE_ACTIVITY_UNAVAILABLE_LABEL = 'Not available'
